import ReportSchedule from ".";

export const reportScheduleRoutes = [
  {
    path: "/reportSchedule",
    element: <ReportSchedule />,
  },
];
